// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 5 ? "html2canvas" : chunkId) + "." + {"5":"575a1f87897095f7","10":"5564819fc0233e50","218":"dc041a9269083cf8","970":"15e1b10988995f29"}[chunkId] + ".js";
};